import React, { useContext, useEffect, useState } from 'react';
import IframeComm from 'react-iframe-comm';
import { useSelector } from 'react-redux';
// import { useRouter } from 'next/router';
import { ThemeContext, ConsentContext } from '../../../../context';
import { domain } from '../../../../utils/variables';
import { createRelativeUrl, postIframe } from '../../../../utils/functions';
import { useOfficialDomain } from '../../../../hooks';

const SyncWithPublicSite = () => {
  // const [enableIframe, setEnableIframe] = useState(false);
  const { themeName } = useContext(ThemeContext);
  const { consent } = useContext(ConsentContext);
  const yourLocation = useSelector((state) => state.locations.yourLocation);
  // const language = useSelector(state => state.locations.language);
  const alpha2 = yourLocation?.parentTerritory?.alpha2 || yourLocation?.alpha2;
  const user = useSelector((state) => state.auth.user);
  const accessToken = user?.accessToken;
  const { otherDomain, officialDomain } = useOfficialDomain();
  // domain.publicSite
  const websiteUrl = domain.publicSite && `${domain.publicSite}/update-data`;
  const otherPWAUrl =
    otherDomain && officialDomain !== otherDomain && `${otherDomain}/embed/update-data`;

  const mobileUrl = domain.mobileApp && `${domain.mobileApp}/embed/update-data`;

  const [iframeUrls, setIframeUrls] = useState([]);
  // iframe has loaded
  const onReady = () => {
    // console.log('onReady');
    postIframe({
      key: 'storage-updated',
    });
  };

  useEffect(() => {
    // console.log('themeName', themeName);
    // console.log('alpha2', alpha2);
    // console.log('language', language);
    // console.log('enableIframe: ', enableIframe);

    const keys = consent?.customConsent || [];
    const cookies = consent?.cookies || [];
    const consentValue = consent?.consent;
    const cookiePolicyVersion = consent?.version;

    const cookieString = JSON.stringify(cookies);
    const delimiter = '@';
    const keyString = JSON.stringify(keys);
    const versionString = cookiePolicyVersion;
    // const keyChain = `${keys?.map((key) => key).join(',')}@${cookies
    //  ?.map((cookie) => cookie?.cookieId)
    //  .join(',')}@${cookiePolicyVersion}`;
    const keyChain = `${keyString}${delimiter}${cookieString}${delimiter}${versionString}`;
    // console.log('keyChain: ', keyChain);

    const params = {
      theme: themeName,
      alpha2,
      accessToken,
      // language,
      consent: consentValue, // Cookies.getCookie(consentKey),
      // customConsent: keyChain, // Cookies.getCookie(customConsentKey),
      // c: alpha2,
    };
    /// if (alpha2 === 'TT' || alpha2 === 'BB' || alpha2 === 'JM' || alpha2 === 'AN') {
    // params.alpha2 = alpha2;
    // }

    const websiteParams = { ...params };
    if (yourLocation?.parentTerritory?.alpha2 === 'AN') {
      websiteParams.alpha2 = 'AN';
    }

    const newWebsiteUrl = createRelativeUrl({
      path: websiteUrl,
      queryObject: params,
    });
    const newOtherPWAUrl = createRelativeUrl({
      path: otherPWAUrl,
      queryObject: params,
    });
    const newMobileUrl = createRelativeUrl({
      path: mobileUrl,
      queryObject: params,
    });
    // console.log('newSetUrl: ', newSetUrl);
    const newUrls = [newWebsiteUrl, newOtherPWAUrl, newMobileUrl];
    // console.log('newUrls: ', newUrls);
    setIframeUrls(newUrls);
  }, [themeName, JSON.stringify(consent), alpha2, accessToken]);

  // console.log('enableIframe: ', enableIframe);
  return (
    <div style={{ display: 'none' }}>
      {consent?.consent &&
        iframeUrls &&
        iframeUrls?.length > 0 &&
        iframeUrls?.map((iframeUrl) => {
          const attributes = {
            src: iframeUrl,
            width: '100%',
            height: '200',
            frameBorder: 1,
          };
          if (!iframeUrl) return null;
          return (
            <IframeComm
              attributes={attributes}
              // postMessageData={postMessageData}
              handleReady={onReady}
            />
          );
        })}
    </div>
  );
};

export default SyncWithPublicSite;
